import React from 'react';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import DataSourceTable from './dataSourceTable';

const DataSources = () => {
    return (
        <>
            <FilterBar/>
            {/*  */}
            <Grid container spacing={2}>
                {/* Data Source Table */}
                <Grid item xs={12}>
                    <DataSourceTable/>
                </Grid>
            </Grid>
        </>
    )
}

export default DataSources;